import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  DialogActions,
} from '@mui/material';

import { TP_COLORS } from '../../../../constants';

type TShowAnswerConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onShowAnswer: () => void;
};

const ShowAnswerConfirmationModal: React.FC<TShowAnswerConfirmationModalProps> = ({
  open,
  onClose,
  onShowAnswer,
}) => {
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { m: '15px' } }}>
      <DialogContent>
        <Box component="div" role="presentation">
          <div style={{ marginBottom: '20px' }}>
            <Typography variant="h5" fontWeight={600} textAlign="center">
              Show Answer
            </Typography>
          </div>
          <div>
            <Typography textAlign="center" fontWeight={500}>
              By clicking yes, you will no longer be able to answer the
              question.
            </Typography>
          </div>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '15px', justifyContent: 'center' }}>
        <Button
          variant="contained"
          color="inherit"
          onClick={onClose}
          sx={{
            backgroundColor: '#E2E8F0',
            color: TP_COLORS.black,
            borderRadius: '30px',
            fontWeight: 600,
            boxShadow: '#CBD5E1 1px 3px 0px',
          }}
        >
          Continue solving
        </Button>
        <Button
          variant="contained"
          color="inherit"
          onClick={onShowAnswer}
          sx={{
            color: TP_COLORS.white,
            fontWeight: 600,
            backgroundColor: '#01A79F',
            borderRadius: '30px',
            boxShadow: 'rgb(1, 115, 109) 1px 3px 0px',
            minWidth: '100px',
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowAnswerConfirmationModal;
